import { Link, useNavigate, useParams } from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner';
import { useGetClientByIdQuery } from '../../Features/clientsSlice';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    ScriptableContext,
    Filler,
  } from 'chart.js';
  import { Bar, Line, Pie } from 'react-chartjs-2';
import {  useGetClientSalesUserSalesSummaryReportQuery } from '../../Features/dataAnalysisReportingSlice';
import ClientHeaderView from '../App/ClientHeaderView';
import jsPDF from "jspdf";
import { DocumentIcon } from '@heroicons/react/solid';
import { selectCurrentUser } from '../../Features/auth/authSlice';
import { useSelector } from 'react-redux';
import { useGetAgentUserProfileByIdQuery } from '../../Features/usersSlice';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
    Filler
  );

function ClientSalesUserSalesReportSummaryView() {
    const navigate = useNavigate();
    const  user  = useSelector(selectCurrentUser);
    const { user_id } = useParams();
  
    const client_id = user.client_id;

    const {
        data: client,
        isSuccess: isSuccessClient,
        isLoading: isLoadingClient,
        isError: isErrorClient,
        error: errorClient
    } = useGetClientByIdQuery(client_id);

    const {
      data: salesUserProfile,
      isSuccess: isSuccessSalesUserProfile,
      isLoading: isLoadingSalesUserProfile,
      isError: isErrorSalesUserProfile,
      error: errorSalesUserProfile
  } = useGetAgentUserProfileByIdQuery(user_id);

const {
    data: clientSalesReport,
    isSuccess: isSuccessClientSalesReport,
    isLoading: isLoadingClientSalesReport,
    isError: isErrorClientSalesReport,
    error: errorClientSalesReport
} = useGetClientSalesUserSalesSummaryReportQuery({client_id: client_id, agent_user_id: user_id});

const formatDisplayDate = (date)=>{
    let tempDate = new Date(date);
    let month = tempDate.toLocaleString('default',{month: 'short'});
    return month + "-" + tempDate.getFullYear();
  }

  const formatDisplayDateForDayMonth = (date)=>{
    let tempDate = new Date(date);
    let month = tempDate.toLocaleString('default',{month: 'short'});
    return month + "-" + tempDate.getDate();
  }

  const numberWithCommas = (x)=>{
    return (x !==null)? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null;
  }

  const chartBgColor = {
    id: 'chartBgColor',
    beforeDraw: (chart, options)=>{
      const{ ctx, width, height }= chart;
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, width, height);
      ctx.restore();
    }
  }


    return   (
                <div className="bg-gray-100">
                    <ClientHeaderView />
                     {
                        (isSuccessSalesUserProfile)?
                            <div className="flex justify-center items-center bg-gray-50 p-1">
                                <h1 className="text-xs text-gray-700 uppercase font-semibold p-2">{salesUserProfile.data.fname} {salesUserProfile.data.lname}s' sales reports</h1>
                            </div>
                         : null
                     }
                      {
                        (isSuccessClientSalesReport)?
                          (clientSalesReport.data.length)?
                            <div>
                              {
                                (isSuccessClient)?
                                    <div class="mt-4 sm:mt-0  md:pt-4 space-y-4 md:mr-28 md:ml-28  lg:mr-28 lg:ml-28 mb-12">
                                        <div class="grid grid-cols-1">         
                                            {
                                                  clientSalesReport.data.map(data => (
                                                      (data.last28Days)?
                                                      <div>
                                                        <div>
                                                          <Line
                                                              height={260}
                                                              data={{
                                                                labels: (data.last28Days)? data.last28Days.map(data=>formatDisplayDateForDayMonth(data.date)): '',
                                                                datasets: [
                                                                  {
                                                                    label: 'Total sales',
                                                                    data: (data.last28Days)? data.last28Days.map(data=>data.total): '',
                                                                    fill: "start",
                                                                    backgroundColor: (context: ScriptableContext<"line">) => {
                                                                      const ctx = context.chart.ctx;
                                                                      const gradient = ctx.createLinearGradient(0, 0, 0, 260);
                                                                      gradient.addColorStop(1, 'rgba(80, 120, 255, 0.13)');
                                                                      gradient.addColorStop(0, 'rgba(250,174,50,0.6)');
                                                                      return gradient;
                                                                    },
                                                                    borderColor: 'rgba(80, 120, 255, 0.13)',
                                                                    borderWidth: 1
                                                                  },
                                                                ]
                                                              }}
                                                              options={{
                                                                bezierCurve: true,
                                                                plugins: {
                                                                  color: "red",
                                                                  legend: {
                                                                    position: 'top',
                                                                  },
                                                                  title: {
                                                                    display: true,
                                                                    text: 'Last 28 days daily sales report',
                                                                  },
                                                                  tooltip: {
                                                                    enabled: false
                                                                  },
                                                                  datalabels: {
                                                                    align: 'top',
                                                                    labels: {
                                                                      value: {
                                                                        color: 'black',
                                                                        font: {
                                                                          weight: ''
                                                                        }
                                                                      }
                                                                    },
                                                                    formatter: (value)=>{
                                                                      return numberWithCommas(value);
                                                                    }
                                                                  }
                                                                },
                                                                elements: {
                                                                  line: {
                                                                    tension: 0.16
                                                                  }
                                                                },
                                                                maintainAspectRatio: false,
                                                                scales: {
                                                                  yAxes: [
                                                                    {
                                                                      ticks: {
                                                                        beginAtZero: true,
                                                                        stepSize: 10
                                                                      }
                                                                    }
                                                                  ]
                                                                },
                                                                layout: {
                                                                  padding: {
                                                                      right: 50,
                                                                  }
                                                                }
                                                              }
                                                            }
                                                            plugins={[chartBgColor]}
                                                            />
                                                        </div>
                                                      </div>
                                                      :null
                                                  ))
                                            }
                                        </div>
                                        <div class="grid grid-cols-1">         
                                            {
                                                  clientSalesReport.data.map(data => (
                                                      (data.last4weeks)?
                                                      <div>
                                                        <div>
                                                          <Bar
                                                              height={260}
                                                              data={{
                                                                labels: (data.last4weeks)? data.last4weeks.map(data=>formatDisplayDateForDayMonth(data.start_date)+' - '+formatDisplayDateForDayMonth(data.end_date)): '',
                                                                datasets: [
                                                                  {
                                                                    label: 'Total sales',
                                                                    data: (data.last4weeks)? data.last4weeks.map(data=>data.total): '',
                                                                    fill: "start",
                                                                    backgroundColor: (context: ScriptableContext<"line">) => {
                                                                      const ctx = context.chart.ctx;
                                                                      const gradient = ctx.createLinearGradient(0, 0, 0, 260);
                                                                      gradient.addColorStop(1, 'rgba(80, 120, 255, 0.13)');
                                                                      gradient.addColorStop(0, 'rgba(250,174,50,0.6)');
                                                                      return gradient;
                                                                    },
                                                                    borderColor: 'rgba(80, 120, 255, 0.13)',
                                                                    borderWidth: 0.6,
                                                                    borderRadius: 3
                                                                  },
                                                                ]
                                                              }}
                                                              options={{
                                                                bezierCurve: true,
                                                                plugins: {
                                                                  color: "red",
                                                                  legend: {
                                                                    position: 'top',
                                                                  },
                                                                  title: {
                                                                    display: true,
                                                                    text: 'Last 4 weeks weekly sales report',
                                                                  },
                                                                  tooltip: {
                                                                    enabled: false
                                                                  },
                                                                  datalabels: {
                                                                    align: 'top',
                                                                    labels: {
                                                                      value: {
                                                                        color: 'black',
                                                                        font: {
                                                                          weight: ''
                                                                        }
                                                                      }
                                                                    },
                                                                    formatter: (value)=>{
                                                                      return numberWithCommas(value);
                                                                    }
                                                                  }
                                                                },
                                                                elements: {
                                                                  line: {
                                                                    tension: 0.16
                                                                  }
                                                                },
                                                                maintainAspectRatio: false,
                                                                scales: {
                                                                  yAxes: [
                                                                    {
                                                                      ticks: {
                                                                        beginAtZero: true,
                                                                        stepSize: 10
                                                                      }
                                                                    }
                                                                  ]
                                                                }
                                                              }
                                                            }
                                                            plugins={[chartBgColor]}
                                                            />
                                                        </div>
                                                      </div>
                                                      :null
                                                  ))
                                            }
                                        </div>
                                        <div class="ggrid grid-cols-2">         
                                            {
                                              clientSalesReport.data.map(data => (
                                                  (data.last3Months)?
                                                    <div>
                                                      <div>                                                          
                                                        <Bar
                                                            height={260}
                                                            data={{
                                                            labels: (data.last3Months)? data.last3Months.map(data=>data.monthname): '',
                                                            datasets: [
                                                                    {
                                                                    label: 'Total sales',
                                                                    data: (data.last3Months)? data.last3Months.map(data=>data.total): '',
                                                                    fill: "start",
                                                                    backgroundColor: (context: ScriptableContext<"line">) => {
                                                                      const ctx = context.chart.ctx;
                                                                      const gradient = ctx.createLinearGradient(0, 0, 0, 260);
                                                                      gradient.addColorStop(1, 'rgba(80, 120, 255, 0.13)');
                                                                      gradient.addColorStop(0, 'rgba(250,174,50,0.6)');
                                                                      return gradient;
                                                                    },
                                                                    borderColor: 'rgba(80, 120, 255, 0.13)',
                                                                    borderWidth: 0.6,
                                                                    borderRadius: 3
                                                                    },
                                                            ]
                                                        }}
                                                        options={{
                                                            bezierCurve : true,
                                                            plugins: {
                                                              legend: {
                                                                position: 'top',
                                                              },
                                                              title: {
                                                                display: true,
                                                                text: 'Last 3 months monthly sales report',
                                                              },
                                                              tooltip: {
                                                                enabled: false
                                                              },
                                                              datalabels: {
                                                                align: 'top',
                                                                color: 'black',
                                                                labels: {
                                                                  value: {
                                                                    font: {
                                                                      weight: ''
                                                                    }
                                                                  }
                                                                },
                                                                formatter: (value)=>{
                                                                  return numberWithCommas(value);
                                                                }
                                                              }
                                                            },
                                                            elements: {
                                                                line: {
                                                                  tension: 0.55
                                                                }
                                                              },
                                                            maintainAspectRatio: false,
                                                            scales: {
                                                              yAxes: [
                                                                {
                                                                  ticks: {
                                                                    beginAtZero: true,
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                        }}
                                                        plugins={[chartBgColor]}
                                                        />
                                                      </div>
                                                    </div>
                                                  :null
                                              ))
                                            }
                                        </div>
                                    </div>
                                : isLoadingClient?
                                    <LoadingSpinner />
                                : isErrorClient?
                                    <div className="md:flex flex-col p-4 mb-20">
                                        <p className="text-blue-500 italic border-b border-black flex flex-1">Data not available</p>
                                    </div>
                                : null
                                
                            }
                            </div>
                          :
                            <div className="md:flex flex-col p-4 mb-20">
                              <p className="text-blue-500 italic border-b border-black flex flex-1">Data not available</p>
                            </div>
                        : isLoadingClientSalesReport?
                          <LoadingSpinner />
                        : isErrorClientSalesReport?
                          <div className="md:flex flex-col p-4 mb-20">
                              <p className="text-blue-500 italic border-b border-black flex flex-1">Data not available</p>
                          </div>
                        :null
                      }
                </div>
    )
}

export default ClientSalesUserSalesReportSummaryView;
